/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opportunitiescolumncity2Inputs */

const en_opportunitiescolumncity2 = /** @type {(inputs: Opportunitiescolumncity2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`City`)
};

const de_opportunitiescolumncity2 = /** @type {(inputs: Opportunitiescolumncity2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stadt`)
};

/**
* | output |
* | --- |
* | "City" |
*
* @param {Opportunitiescolumncity2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const opportunitiescolumncity2 = /** @type {((inputs?: Opportunitiescolumncity2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opportunitiescolumncity2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opportunitiescolumncity2(inputs)
	return de_opportunitiescolumncity2(inputs)
});
export { opportunitiescolumncity2 as "opportunitiesColumnCity" }